import compress from 'browser-image-compression';
import { transliterate } from 'ui/utils';

export const compressImage = async (file: File, { maxSizeMB = 1 } = {}): Promise<File> => {
  const compressed = await compress(file, {
    maxSizeMB,
    maxWidthOrHeight: 300,
    fileType: 'image/jpeg',
  });

  return new File([compressed], file.name, { type: compressed.type });
};

const fileNameRegExp = /^[^а-яА-ЯёЁ]*$/;

export const fileToBase64 = (file: File, withType = false): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result?.toString()?.split(',')[1];
      if (!base64String) {
        reject(new Error('Failed to convert file to base64'));
        return;
      }
      let fileName = file.name;
      if (!fileNameRegExp.test(fileName)) {
        fileName = transliterate(fileName); //reject(new Error('Failed to convert file to base64'));
      }

      const base64StringWithType = `data:${file.type};name=${fileName.replaceAll(
        ' ',
        '_',
      )};base64,${base64String}`;

      resolve(withType ? base64StringWithType : base64String);
    };
    reader.onerror = error => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

export const normalizeFileName = (name: string): string => {
  const canBeNormalized = !!name.match(/^.+_.{8}\..{2,4}/);
  if (!canBeNormalized) {
    return name;
  }

  const res = name.split('');
  res.splice(name.lastIndexOf('_'), 9);
  return res.join('');
};

export const getFileNameFromBase64String = (base64String: string): string => {
  const match = base64String.match(/name=.+;/);

  return match ? match[0].slice(5, match[0].length - 1) : '';
};

export const getBase64BytesSize = (file: string) => {
  const paddingCount = file.endsWith('==') ? 2 : file.endsWith('=') ? 1 : 0;

  return Math.floor((file.length * 3) / 4) - paddingCount;
};
